import { Component, Input, OnInit } from '@angular/core';
import { Meal, Product } from 'src/app/api/contracts/product';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnInit {
  @Input() meal!: Product;
  @Input() hideBuyButton: boolean = false;

  constructor() {}

  ngOnInit() {
    return;
  }
}
